import { render, staticRenderFns } from "./SharedShortlistsSelector.vue?vue&type=template&id=83329318&"
import script from "./SharedShortlistsSelector.vue?vue&type=script&lang=js&"
export * from "./SharedShortlistsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports